<div segundo class="ui-g-12 ui-g-nopad">
    <ng-content></ng-content>
</div>
